/**
 * @file 取り込んだ資料のページ画像 (紙 1 ページ = 1 画像) の一覧のクライアント。
 * @what: `GET /families/{familyId}/study/sources/{sourceId}/pages` (ページ順)。画像本体は
 *   Firebase Storage から直接取得する (storage.rules の family member read)。
 * @why: 資料に pages があればページで読め、items があれば問題集の見せ方になり、両方あれば
 *   切り替える (epic_23 §8)。何が入っているかは一覧の有無で決まるので、資料側に形式の
 *   列挙型を持たない。
 * @failure: ApiError を伝播。一覧が空 = ページ画像を取り込んでいない、は正常系。
 */

import { apiFetch } from "@/shared/api/client";

export interface StudyPage {
  /** 紙のページ番号 (1 始まり)。 */
  page: number;
  image_path: string;
  content_type: string;
  /**
   * このページに付く付属音声の Storage パス (無い資料では項目ごと来ない)。音声1本が
   * 数ページ (紙面に刷られた TRACK の単位) にまたがるので、同じ値を持つページが並ぶ。
   */
  audio_path?: string;
  audio_content_type?: string;
}

export async function fetchSourcePages(
  familyId: string,
  sourceId: string,
  signal?: AbortSignal,
): Promise<StudyPage[]> {
  const res = await apiFetch<{ pages: StudyPage[] }>(
    `/families/${encodeURIComponent(familyId)}/study/sources/${encodeURIComponent(sourceId)}/pages`,
    signal ? { signal } : {},
  );
  return res.pages;
}
